import {ScrollTrigger} from "../LibrariesImport";

export default class BlockClient {

	static init() {
		document.querySelectorAll('.client-filters').forEach((filters) => {
			const block = filters.parentElement;
			const buttons = filters.querySelectorAll('[data-client-filter]');
			const items = block.querySelectorAll('[data-categories]');

			buttons.forEach((button) => {
				button.addEventListener('click', () => {
					// Un nouveau clic sur la catégorie active la désélectionne et réaffiche tous les logos
					const filter = button.classList.contains('active') ? '' : button.dataset.clientFilter;

					buttons.forEach((item) => {
						const isActive = item.dataset.clientFilter === filter;
						item.classList.toggle('active', isActive);
						item.setAttribute('aria-pressed', isActive);
					});

					items.forEach((item) => {
						const categories = item.dataset.categories.split(' ');
						item.classList.toggle('is-hidden', filter !== '' && !categories.includes(filter));
					});

					// La hauteur de la page change : on recalcule les animations au scroll
					ScrollTrigger.refresh();
				});
			});
		});
	}

}
